export const adminUsersEndpoints = {
  list: '/admin/users',
  detail: (id: string) => `/admin/users/${id}`,
  create: '/admin/users',
  edit: (id: string) => `/admin/users/${id}/roles`,
  delete: (id: string) => `/admin/users/${id}`,
}

export const adminUsersBackendErrors = {
  ADMIN_USER_USERNAME_ALREADY_EXISTS: 'Bu kullanıcı adı zaten kullanılıyor.',
  ADMIN_USER_EMAIL_ALREADY_EXISTS: 'Bu e-posta adresi zaten kullanılıyor.',
  ADMIN_USER_NOT_DELETED_SELF: 'Kendi hesabınızı silemezsiniz.',
  ADMIN_USER_CREDENTIALS_NOT_MATCHED: 'Bilgiler eşleşmedi.',
  ADMIN_USER_CREATE: 'Yönetici  oluşturulamadı.',
  ADMIN_USER_NOT_FOUND: 'Yönetici bulunamadı.',
  ADMIN_USER_DELETE: 'Yönetici silinemedi.',
  AUTH_USERNAME_CONTAINS_SPACE: 'Kullanıcı adı boşluk içeremez.',
  AUTH_MISSING_UPPERCASE: 'Şifre en az bir büyük harf içermelidir.',
  AUTH_MISSING_SPECIAL_CHAR: 'Şifre en az bir özel karakter içermelidir.',
}

export const adminSuccessMessages = {
  adminCreate: 'Yönetici başarıyla oluşturuldu!',
  adminEdit: 'Yönetici başarıyla düzenlendi!',
  adminDelete: 'Yönetici başarıyla silindi!',
}
